module.exports = __webpack_public_path__ + "img/device_1001_1.cf07cd0b.svg";